// This file is auto-generated by @hey-api/openapi-ts

import { type DefaultError, type InfiniteData, infiniteQueryOptions, queryOptions, type UseMutationOptions } from '@tanstack/react-query';

import { client } from '../client.gen';
import { accessStripePortal, addExcludedDate, archiveCourse, bulkImportParents, checkout, completeRegistration, confirmDraftInvoices, confirmInvitation, createAndSendSignupLink, createCourse, createDebtForgiveness, createInvitation, createManualPayment, createParent, createPaymentSession, createSetupSession, createStudent, createTeacher, deleteAttendance, deleteCourse, deleteDraftInvoices, deleteInvitation, deleteParent, deletePaymentMethod, deleteStudent, deleteTeacher, deleteUser, downloadInvoicePdf, enrollStudent, estimateSms, executeCronTask, exportAttendanceExcel, filterParents, forgotPassword, generateMonthlyInvoice, generateMonthlyInvoicesForAllParents, generateMonthlyInvoicesForAllParentsDraft, getAllCourses, getAllCronTasks, getAllInvitations, getAllInvoices, getAllNotifications, getAllParents, getAllPayments, getAllStudents, getAllTeachers, getAllUsers, getAttendancesByCourse, getAttendancesByDate, getAttendancesBySchoolAndDate, getAttendancesByStudent, getCourseById, getDashboard, getDraftInvoices, getFailedNotifications, getInvoiceById, getInvoiceDetail, getInvoiceItems, getInvoices, getInvoices1, getInvoicesByParent, getLevels, getMe, getNewEnrollments, getParentById, getPaymentById, getPaymentDetail, getPaymentMethods, getPayments, getPaymentStatus, getProfile, getSchools, getSignupLinkData, getStripePaymentMethods, getStripePortalSession, getStudentById, getStudentsByParent, getSubjects, getTeacherById, getTimeSlots, importAttendanceExcel, login, moveStudent, type Options, preparePayment, previewPayment, processAutomaticPayment, processManualPayment, recordAttendance, refundPayment, register, register1, registerStep1, removeExcludedDate, resendInvoice, resetPassword, retryAllFailedNotifications, retryNotification, saveBulkAttendances, sendBulkSms, sendOtp, sendPasswordResetEmail, sendPaymentLink, sendPaymentReminder, sendSms, setExcludedDates, togglePaymentHold, unarchiveCourse, unenrollStudent, cancelUnenrollStudent, updateAttendance, updateCourse, updateEnrollmentDate, updateMe, updateParent, updatePaymentMethod, updatePaymentMethod1, updateStudent, updateTeacher, updateUserRole, validateInvitation, validateResetToken, verifyOtp } from '../sdk.gen';
import type { AccessStripePortalData, AddExcludedDateData, AddExcludedDateResponse, ArchiveCourseData, ArchiveCourseResponse, BulkImportParentsData, BulkImportParentsResponse, CheckoutData, CompleteRegistrationData, CompleteRegistrationResponse, ConfirmDraftInvoicesData, ConfirmDraftInvoicesResponse, ConfirmInvitationData, ConfirmInvitationResponse2, CreateAndSendSignupLinkData, CreateAndSendSignupLinkResponse, CreateCourseData, CreateCourseResponse, CreateDebtForgivenessData, CreateDebtForgivenessResponse, CreateInvitationData, CreateInvitationResponse, CreateManualPaymentData, CreateManualPaymentResponse, CreateParentData, CreateParentResponse, CreatePaymentSessionData, CreatePaymentSessionResponse2, CreateSetupSessionData, CreateSetupSessionError, CreateSetupSessionResponse, CreateStudentData, CreateStudentResponse, CreateTeacherData, CreateTeacherResponse, DeleteAttendanceData, DeleteAttendanceResponse, DeleteCourseData, DeleteCourseResponse, DeleteDraftInvoicesData, DeleteInvitationData, DeleteParentData, DeleteParentResponse, DeletePaymentMethodData, DeleteStudentData, DeleteStudentResponse, DeleteTeacherData, DeleteTeacherResponse, DeleteUserData, DownloadInvoicePdfData, EnrollStudentData, EstimateSmsData, EstimateSmsResponse, ExecuteCronTaskData, ExecuteCronTaskError, ExecuteCronTaskResponse2, ExportAttendanceExcelData, FilterParentsData, FilterParentsResponse, ForgotPasswordData, ForgotPasswordResponse2, GenerateMonthlyInvoiceData, GenerateMonthlyInvoiceResponse, GenerateMonthlyInvoicesForAllParentsData, GenerateMonthlyInvoicesForAllParentsDraftData, GenerateMonthlyInvoicesForAllParentsDraftResponse, GenerateMonthlyInvoicesForAllParentsResponse, GetAllCoursesData, GetAllCronTasksData, GetAllInvitationsData, GetAllInvoicesData, GetAllNotificationsData, GetAllNotificationsResponse, GetAllParentsData, GetAllPaymentsData, GetAllStudentsData, GetAllTeachersData, GetAllUsersData, GetAttendancesByCourseData, GetAttendancesByDateData, GetAttendancesBySchoolAndDateData, GetAttendancesByStudentData, GetCourseByIdData, GetDashboardData, GetDraftInvoicesData, GetFailedNotificationsData, GetInvoiceByIdData, GetInvoiceDetailData, GetInvoiceItemsData, GetInvoices1Data, GetInvoicesByParentData, GetInvoicesData, GetLevelsData, GetMeData, GetNewEnrollmentsData, GetParentByIdData, GetPaymentByIdData, GetPaymentDetailData, GetPaymentMethodsData, GetPaymentsData, GetPaymentStatusData, GetProfileData, GetSchoolsData, GetSignupLinkDataData, GetStripePaymentMethodsData, GetStripePortalSessionData, GetStudentByIdData, GetStudentsByParentData, GetSubjectsData, GetTeacherByIdData, GetTimeSlotsData, ImportAttendanceExcelData, ImportAttendanceExcelResponse, LoginData, LoginResponse, MoveStudentData, PreparePaymentData, PreparePaymentResponse, PreviewPaymentData, PreviewPaymentResponse, ProcessAutomaticPaymentData, ProcessAutomaticPaymentResponse, ProcessManualPaymentData, ProcessManualPaymentResponse, RecordAttendanceData, RecordAttendanceResponse, RefundPaymentData, RefundPaymentResponse, Register1Data, Register1Response, RegisterData, RegisterResponse, RegisterStep1Data, RegisterStep1Response, RemoveExcludedDateData, RemoveExcludedDateResponse, ResendInvoiceData, ResetPasswordData, ResetPasswordError, ResetPasswordResponse2, RetryAllFailedNotificationsData, RetryAllFailedNotificationsResponse, RetryNotificationData, RetryNotificationResponse, SaveBulkAttendancesData, SaveBulkAttendancesResponse, SendBulkSmsData, SendBulkSmsResponse, SendOtpData, SendPasswordResetEmailData, SendPaymentLinkData, SendPaymentReminderData, SendSmsData, SetExcludedDatesData, SetExcludedDatesResponse, TogglePaymentHoldData, UnarchiveCourseData, UnarchiveCourseResponse, UnenrollStudentData, CancelUnenrollStudentData, UpdateAttendanceData, UpdateAttendanceResponse, UpdateCourseData, UpdateCourseResponse, UpdateEnrollmentDateData, UpdateMeData, UpdateMeResponse, UpdateParentData, UpdateParentResponse, UpdatePaymentMethod1Data, UpdatePaymentMethodData, UpdateStudentData, UpdateStudentResponse, UpdateTeacherData, UpdateTeacherResponse, UpdateUserRoleData, UpdateUserRoleResponse, ValidateInvitationData, ValidateResetTokenData, VerifyOtpData, VerifyOtpResponse } from '../types.gen';

/**
 * Mettre à jour le moyen de paiement
 *
 * Permet à un parent de modifier son moyen de paiement et le token associé
 */
export const updatePaymentMethodMutation = (options?: Partial<Options<UpdatePaymentMethodData>>): UseMutationOptions<unknown, DefaultError, Options<UpdatePaymentMethodData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<UpdatePaymentMethodData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updatePaymentMethod({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Compléter l'inscription d'un parent
 *
 * Ajoute les informations de paiement, commentaires et enfants à un parent créé à l'étape 1
 */
export const completeRegistrationMutation = (options?: Partial<Options<CompleteRegistrationData>>): UseMutationOptions<CompleteRegistrationResponse, DefaultError, Options<CompleteRegistrationData>> => {
    const mutationOptions: UseMutationOptions<CompleteRegistrationResponse, DefaultError, Options<CompleteRegistrationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await completeRegistration({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export type QueryKey<TOptions extends Options> = [
    Pick<TOptions, 'baseUrl' | 'body' | 'headers' | 'path' | 'query'> & {
        _id: string;
        _infinite?: boolean;
        tags?: ReadonlyArray<string>;
    }
];

const createQueryKey = <TOptions extends Options>(id: string, options?: TOptions, infinite?: boolean, tags?: ReadonlyArray<string>): [
    QueryKey<TOptions>[0]
] => {
    const params: QueryKey<TOptions>[0] = { _id: id, baseUrl: options?.baseUrl || (options?.client ?? client).getConfig().baseUrl } as QueryKey<TOptions>[0];
    if (infinite) {
        params._infinite = infinite;
    }
    if (tags) {
        params.tags = tags;
    }
    if (options?.body) {
        params.body = options.body;
    }
    if (options?.headers) {
        params.headers = options.headers;
    }
    if (options?.path) {
        params.path = options.path;
    }
    if (options?.query) {
        params.query = options.query;
    }
    return [
        params
    ];
};

export const getMeQueryKey = (options?: Options<GetMeData>) => createQueryKey('getMe', options);

/**
 * Récupérer son profil
 *
 * Obtenir les informations du parent authentifié
 */
export const getMeOptions = (options?: Options<GetMeData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMe({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMeQueryKey(options)
    });
};

/**
 * Modifier son profil
 *
 * Permet au parent authentifié de modifier ses informations
 */
export const updateMeMutation = (options?: Partial<Options<UpdateMeData>>): UseMutationOptions<UpdateMeResponse, DefaultError, Options<UpdateMeData>> => {
    const mutationOptions: UseMutationOptions<UpdateMeResponse, DefaultError, Options<UpdateMeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateMe({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Changer le rôle d'un utilisateur
 */
export const updateUserRoleMutation = (options?: Partial<Options<UpdateUserRoleData>>): UseMutationOptions<UpdateUserRoleResponse, DefaultError, Options<UpdateUserRoleData>> => {
    const mutationOptions: UseMutationOptions<UpdateUserRoleResponse, DefaultError, Options<UpdateUserRoleData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateUserRole({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Supprimer un professeur
 *
 * Supprimer définitivement un professeur du système
 */
export const deleteTeacherMutation = (options?: Partial<Options<DeleteTeacherData>>): UseMutationOptions<DeleteTeacherResponse, DefaultError, Options<DeleteTeacherData>> => {
    const mutationOptions: UseMutationOptions<DeleteTeacherResponse, DefaultError, Options<DeleteTeacherData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteTeacher({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getTeacherByIdQueryKey = (options: Options<GetTeacherByIdData>) => createQueryKey('getTeacherById', options);

/**
 * Récupérer un professeur par ID
 *
 * Obtenir les détails d'un professeur spécifique avec ses cours et élèves
 */
export const getTeacherByIdOptions = (options: Options<GetTeacherByIdData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getTeacherById({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getTeacherByIdQueryKey(options)
    });
};

/**
 * Mettre à jour un professeur
 *
 * Modifier les informations d'un professeur existant
 */
export const updateTeacherMutation = (options?: Partial<Options<UpdateTeacherData>>): UseMutationOptions<UpdateTeacherResponse, DefaultError, Options<UpdateTeacherData>> => {
    const mutationOptions: UseMutationOptions<UpdateTeacherResponse, DefaultError, Options<UpdateTeacherData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateTeacher({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Supprimer un élève
 *
 * Supprimer définitivement un élève du système
 */
export const deleteStudentMutation = (options?: Partial<Options<DeleteStudentData>>): UseMutationOptions<DeleteStudentResponse, DefaultError, Options<DeleteStudentData>> => {
    const mutationOptions: UseMutationOptions<DeleteStudentResponse, DefaultError, Options<DeleteStudentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteStudent({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getStudentByIdQueryKey = (options: Options<GetStudentByIdData>) => createQueryKey('getStudentById', options);

/**
 * Récupérer un élève par ID
 *
 * Obtenir les détails complets d'un élève spécifique
 */
export const getStudentByIdOptions = (options: Options<GetStudentByIdData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getStudentById({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getStudentByIdQueryKey(options)
    });
};

/**
 * Mettre à jour un élève
 *
 * Modifier les informations d'un élève existant
 */
export const updateStudentMutation = (options?: Partial<Options<UpdateStudentData>>): UseMutationOptions<UpdateStudentResponse, DefaultError, Options<UpdateStudentData>> => {
    const mutationOptions: UseMutationOptions<UpdateStudentResponse, DefaultError, Options<UpdateStudentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateStudent({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Supprimer un parent
 *
 * Supprimer définitivement un parent du système
 */
export const deleteParentMutation = (options?: Partial<Options<DeleteParentData>>): UseMutationOptions<DeleteParentResponse, DefaultError, Options<DeleteParentData>> => {
    const mutationOptions: UseMutationOptions<DeleteParentResponse, DefaultError, Options<DeleteParentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteParent({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getParentByIdQueryKey = (options: Options<GetParentByIdData>) => createQueryKey('getParentById', options);

/**
 * Récupérer un parent par ID
 *
 * Obtenir les informations détaillées d'un parent spécifique
 */
export const getParentByIdOptions = (options: Options<GetParentByIdData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getParentById({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getParentByIdQueryKey(options)
    });
};

/**
 * Mettre à jour un parent
 *
 * Modifier les informations d'un parent existant
 */
export const updateParentMutation = (options?: Partial<Options<UpdateParentData>>): UseMutationOptions<UpdateParentResponse, DefaultError, Options<UpdateParentData>> => {
    const mutationOptions: UseMutationOptions<UpdateParentResponse, DefaultError, Options<UpdateParentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateParent({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Mettre à jour le moyen de paiement
 *
 * Modifier le moyen de paiement d'un parent et le token associé
 */
export const updatePaymentMethod1Mutation = (options?: Partial<Options<UpdatePaymentMethod1Data>>): UseMutationOptions<unknown, DefaultError, Options<UpdatePaymentMethod1Data>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<UpdatePaymentMethod1Data>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updatePaymentMethod1({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Activer/désactiver le blocage de paiement
 *
 * Permet de suspendre ou réactiver les paiements automatiques pour un parent
 */
export const togglePaymentHoldMutation = (options?: Partial<Options<TogglePaymentHoldData>>): UseMutationOptions<unknown, DefaultError, Options<TogglePaymentHoldData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<TogglePaymentHoldData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await togglePaymentHold({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Supprimer un cours
 *
 * Supprimer définitivement un cours du système
 */
export const deleteCourseMutation = (options?: Partial<Options<DeleteCourseData>>): UseMutationOptions<DeleteCourseResponse, DefaultError, Options<DeleteCourseData>> => {
    const mutationOptions: UseMutationOptions<DeleteCourseResponse, DefaultError, Options<DeleteCourseData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteCourse({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getCourseByIdQueryKey = (options: Options<GetCourseByIdData>) => createQueryKey('getCourseById', options);

/**
 * Récupérer un cours par ID
 *
 * Obtenir les détails complets d'un cours spécifique
 */
export const getCourseByIdOptions = (options: Options<GetCourseByIdData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getCourseById({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getCourseByIdQueryKey(options)
    });
};

/**
 * Mettre à jour un cours
 *
 * Modifier les informations d'un cours existant
 */
export const updateCourseMutation = (options?: Partial<Options<UpdateCourseData>>): UseMutationOptions<UpdateCourseResponse, DefaultError, Options<UpdateCourseData>> => {
    const mutationOptions: UseMutationOptions<UpdateCourseResponse, DefaultError, Options<UpdateCourseData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateCourse({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Supprimer une date d'exclusion
 *
 * Supprimer une date où le cours n'avait pas eu lieu
 */
export const removeExcludedDateMutation = (options?: Partial<Options<RemoveExcludedDateData>>): UseMutationOptions<RemoveExcludedDateResponse, DefaultError, Options<RemoveExcludedDateData>> => {
    const mutationOptions: UseMutationOptions<RemoveExcludedDateResponse, DefaultError, Options<RemoveExcludedDateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await removeExcludedDate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Ajouter une date d'exclusion
 *
 * Ajouter une date où le cours n'a pas eu lieu
 */
export const addExcludedDateMutation = (options?: Partial<Options<AddExcludedDateData>>): UseMutationOptions<AddExcludedDateResponse, DefaultError, Options<AddExcludedDateData>> => {
    const mutationOptions: UseMutationOptions<AddExcludedDateResponse, DefaultError, Options<AddExcludedDateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await addExcludedDate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Définir toutes les dates d'exclusion
 *
 * Remplacer toutes les dates d'exclusion d'un cours
 */
export const setExcludedDatesMutation = (options?: Partial<Options<SetExcludedDatesData>>): UseMutationOptions<SetExcludedDatesResponse, DefaultError, Options<SetExcludedDatesData>> => {
    const mutationOptions: UseMutationOptions<SetExcludedDatesResponse, DefaultError, Options<SetExcludedDatesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await setExcludedDates({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Modifier la date d'inscription d'un élève
 *
 * Permet de modifier la date d'inscription d'un élève à un cours
 */
export const updateEnrollmentDateMutation = (options?: Partial<Options<UpdateEnrollmentDateData>>): UseMutationOptions<unknown, DefaultError, Options<UpdateEnrollmentDateData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<UpdateEnrollmentDateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateEnrollmentDate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Supprimer une présence
 *
 * Supprimer définitivement un enregistrement de présence du système
 */
export const deleteAttendanceMutation = (options?: Partial<Options<DeleteAttendanceData>>): UseMutationOptions<DeleteAttendanceResponse, DefaultError, Options<DeleteAttendanceData>> => {
    const mutationOptions: UseMutationOptions<DeleteAttendanceResponse, DefaultError, Options<DeleteAttendanceData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteAttendance({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Mettre à jour une présence
 *
 * Modifier le statut ou les notes d'une présence existante
 */
export const updateAttendanceMutation = (options?: Partial<Options<UpdateAttendanceData>>): UseMutationOptions<UpdateAttendanceResponse, DefaultError, Options<UpdateAttendanceData>> => {
    const mutationOptions: UseMutationOptions<UpdateAttendanceResponse, DefaultError, Options<UpdateAttendanceData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateAttendance({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Créer une session Stripe en mode SETUP
 *
 * Crée une session Stripe pour configurer le moyen de paiement sans effectuer de paiement
 */
export const createSetupSessionMutation = (options?: Partial<Options<CreateSetupSessionData>>): UseMutationOptions<CreateSetupSessionResponse, CreateSetupSessionError, Options<CreateSetupSessionData>> => {
    const mutationOptions: UseMutationOptions<CreateSetupSessionResponse, CreateSetupSessionError, Options<CreateSetupSessionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createSetupSession({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Étape 1 de l'inscription
 *
 * Crée le parent et le customer Stripe avec les informations de base
 */
export const registerStep1Mutation = (options?: Partial<Options<RegisterStep1Data>>): UseMutationOptions<RegisterStep1Response, DefaultError, Options<RegisterStep1Data>> => {
    const mutationOptions: UseMutationOptions<RegisterStep1Response, DefaultError, Options<RegisterStep1Data>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await registerStep1({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Inscription d'un nouveau parent
 *
 * Permet à un parent de s'inscrire avec ses informations et celles de ses enfants
 */
export const registerMutation = (options?: Partial<Options<RegisterData>>): UseMutationOptions<RegisterResponse, DefaultError, Options<RegisterData>> => {
    const mutationOptions: UseMutationOptions<RegisterResponse, DefaultError, Options<RegisterData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await register({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const verifyOtpMutation = (options?: Partial<Options<VerifyOtpData>>): UseMutationOptions<VerifyOtpResponse, DefaultError, Options<VerifyOtpData>> => {
    const mutationOptions: UseMutationOptions<VerifyOtpResponse, DefaultError, Options<VerifyOtpData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await verifyOtp({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const sendOtpMutation = (options?: Partial<Options<SendOtpData>>): UseMutationOptions<unknown, DefaultError, Options<SendOtpData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<SendOtpData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await sendOtp({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Prévisualiser un paiement
 *
 * Obtenir la répartition prévisionnelle d'un paiement sur les factures en attente
 */
export const preparePaymentMutation = (options?: Partial<Options<PreparePaymentData>>): UseMutationOptions<PreparePaymentResponse, DefaultError, Options<PreparePaymentData>> => {
    const mutationOptions: UseMutationOptions<PreparePaymentResponse, DefaultError, Options<PreparePaymentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await preparePayment({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Créer une session de paiement HelloAsso
 *
 * Générer une URL de paiement HelloAsso pour régulariser des factures
 */
export const createPaymentSessionMutation = (options?: Partial<Options<CreatePaymentSessionData>>): UseMutationOptions<CreatePaymentSessionResponse2, DefaultError, Options<CreatePaymentSessionData>> => {
    const mutationOptions: UseMutationOptions<CreatePaymentSessionResponse2, DefaultError, Options<CreatePaymentSessionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createPaymentSession({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Confirmer une invitation et créer le compte
 *
 * Permet de confirmer une invitation en fournissant un token et un mot de passe pour créer le compte utilisateur
 */
export const confirmInvitationMutation = (options?: Partial<Options<ConfirmInvitationData>>): UseMutationOptions<ConfirmInvitationResponse2, DefaultError, Options<ConfirmInvitationData>> => {
    const mutationOptions: UseMutationOptions<ConfirmInvitationResponse2, DefaultError, Options<ConfirmInvitationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await confirmInvitation({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Exécuter une tâche cron avec une date simulée
 *
 * Permet d'exécuter manuellement une tâche cron avec une date spécifique pour les tests ou l'administration
 */
export const executeCronTaskMutation = (options?: Partial<Options<ExecuteCronTaskData>>): UseMutationOptions<ExecuteCronTaskResponse2, ExecuteCronTaskError, Options<ExecuteCronTaskData>> => {
    const mutationOptions: UseMutationOptions<ExecuteCronTaskResponse2, ExecuteCronTaskError, Options<ExecuteCronTaskData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await executeCronTask({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Réinitialiser le mot de passe avec un token
 *
 * Permet de définir un nouveau mot de passe en utilisant un token de réinitialisation valide
 */
export const resetPasswordMutation = (options?: Partial<Options<ResetPasswordData>>): UseMutationOptions<ResetPasswordResponse2, ResetPasswordError, Options<ResetPasswordData>> => {
    const mutationOptions: UseMutationOptions<ResetPasswordResponse2, ResetPasswordError, Options<ResetPasswordData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await resetPassword({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const register1Mutation = (options?: Partial<Options<Register1Data>>): UseMutationOptions<Register1Response, DefaultError, Options<Register1Data>> => {
    const mutationOptions: UseMutationOptions<Register1Response, DefaultError, Options<Register1Data>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await register1({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const loginMutation = (options?: Partial<Options<LoginData>>): UseMutationOptions<LoginResponse, DefaultError, Options<LoginData>> => {
    const mutationOptions: UseMutationOptions<LoginResponse, DefaultError, Options<LoginData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await login({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Demander une réinitialisation de mot de passe
 *
 * Envoie un email avec un lien de réinitialisation si l'adresse email existe dans le système
 */
export const forgotPasswordMutation = (options?: Partial<Options<ForgotPasswordData>>): UseMutationOptions<ForgotPasswordResponse2, DefaultError, Options<ForgotPasswordData>> => {
    const mutationOptions: UseMutationOptions<ForgotPasswordResponse2, DefaultError, Options<ForgotPasswordData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await forgotPassword({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Envoyer un email de réinitialisation de mot de passe
 */
export const sendPasswordResetEmailMutation = (options?: Partial<Options<SendPasswordResetEmailData>>): UseMutationOptions<unknown, DefaultError, Options<SendPasswordResetEmailData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<SendPasswordResetEmailData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await sendPasswordResetEmail({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getAllTeachersQueryKey = (options?: Options<GetAllTeachersData>) => createQueryKey('getAllTeachers', options);

/**
 * Récupérer tous les professeurs
 *
 * Obtenir la liste complète de tous les professeurs
 */
export const getAllTeachersOptions = (options?: Options<GetAllTeachersData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getAllTeachers({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getAllTeachersQueryKey(options)
    });
};

/**
 * Créer un nouveau professeur
 *
 * Permet de créer un nouveau professeur dans le système
 */
export const createTeacherMutation = (options?: Partial<Options<CreateTeacherData>>): UseMutationOptions<CreateTeacherResponse, DefaultError, Options<CreateTeacherData>> => {
    const mutationOptions: UseMutationOptions<CreateTeacherResponse, DefaultError, Options<CreateTeacherData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createTeacher({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getAllStudentsQueryKey = (options?: Options<GetAllStudentsData>) => createQueryKey('getAllStudents', options);

/**
 * Récupérer tous les élèves
 *
 * Obtenir la liste de tous les élèves du système
 */
export const getAllStudentsOptions = (options?: Options<GetAllStudentsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getAllStudents({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getAllStudentsQueryKey(options)
    });
};

/**
 * Créer un nouvel élève
 *
 * Permet de créer un nouvel élève dans le système
 */
export const createStudentMutation = (options?: Partial<Options<CreateStudentData>>): UseMutationOptions<CreateStudentResponse, DefaultError, Options<CreateStudentData>> => {
    const mutationOptions: UseMutationOptions<CreateStudentResponse, DefaultError, Options<CreateStudentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createStudent({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Envoyer des SMS groupés
 *
 * Envoyer des SMS à plusieurs parents en une seule opération (asynchrone)
 */
export const sendBulkSmsMutation = (options?: Partial<Options<SendBulkSmsData>>): UseMutationOptions<SendBulkSmsResponse, DefaultError, Options<SendBulkSmsData>> => {
    const mutationOptions: UseMutationOptions<SendBulkSmsResponse, DefaultError, Options<SendBulkSmsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await sendBulkSms({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Filtrer les parents
 *
 * Filtrer les parents selon différents critères (cours, école, date, statut paiement)
 */
export const filterParentsMutation = (options?: Partial<Options<FilterParentsData>>): UseMutationOptions<FilterParentsResponse, DefaultError, Options<FilterParentsData>> => {
    const mutationOptions: UseMutationOptions<FilterParentsResponse, DefaultError, Options<FilterParentsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await filterParents({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Estimer le coût d'envoi de SMS
 *
 * Calculer le coût estimé pour l'envoi de SMS groupés avant l'envoi réel
 */
export const estimateSmsMutation = (options?: Partial<Options<EstimateSmsData>>): UseMutationOptions<EstimateSmsResponse, DefaultError, Options<EstimateSmsData>> => {
    const mutationOptions: UseMutationOptions<EstimateSmsResponse, DefaultError, Options<EstimateSmsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await estimateSms({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Créer un lien d'inscription et l'envoyer par SMS
 *
 * Génère un lien d'inscription pré-rempli avec les informations de l'élève et l'envoie par SMS au parent
 */
export const createAndSendSignupLinkMutation = (options?: Partial<Options<CreateAndSendSignupLinkData>>): UseMutationOptions<CreateAndSendSignupLinkResponse, DefaultError, Options<CreateAndSendSignupLinkData>> => {
    const mutationOptions: UseMutationOptions<CreateAndSendSignupLinkResponse, DefaultError, Options<CreateAndSendSignupLinkData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createAndSendSignupLink({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Rembourser un paiement
 *
 * Effectuer un remboursement total ou partiel d'un paiement
 */
export const refundPaymentMutation = (options?: Partial<Options<RefundPaymentData>>): UseMutationOptions<RefundPaymentResponse, DefaultError, Options<RefundPaymentData>> => {
    const mutationOptions: UseMutationOptions<RefundPaymentResponse, DefaultError, Options<RefundPaymentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await refundPayment({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Prévisualiser un paiement
 *
 * Obtenir la répartition prévisionnelle d'un paiement sur les factures
 */
export const previewPaymentMutation = (options?: Partial<Options<PreviewPaymentData>>): UseMutationOptions<PreviewPaymentResponse, DefaultError, Options<PreviewPaymentData>> => {
    const mutationOptions: UseMutationOptions<PreviewPaymentResponse, DefaultError, Options<PreviewPaymentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await previewPayment({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Traiter un paiement manuel
 *
 * Enregistrer un paiement effectué manuellement (chèque, espèces, virement)
 */
export const processManualPaymentMutation = (options?: Partial<Options<ProcessManualPaymentData>>): UseMutationOptions<ProcessManualPaymentResponse, DefaultError, Options<ProcessManualPaymentData>> => {
    const mutationOptions: UseMutationOptions<ProcessManualPaymentResponse, DefaultError, Options<ProcessManualPaymentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await processManualPayment({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Créer un paiement manuel multi-factures
 *
 * Enregistrer un paiement manuel pouvant être réparti sur plusieurs factures
 */
export const createManualPaymentMutation = (options?: Partial<Options<CreateManualPaymentData>>): UseMutationOptions<CreateManualPaymentResponse, DefaultError, Options<CreateManualPaymentData>> => {
    const mutationOptions: UseMutationOptions<CreateManualPaymentResponse, DefaultError, Options<CreateManualPaymentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createManualPayment({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Effacer une dette (debt forgiveness)
 *
 * Annuler une dette d'un parent (remise gracieuse)
 */
export const createDebtForgivenessMutation = (options?: Partial<Options<CreateDebtForgivenessData>>): UseMutationOptions<CreateDebtForgivenessResponse, DefaultError, Options<CreateDebtForgivenessData>> => {
    const mutationOptions: UseMutationOptions<CreateDebtForgivenessResponse, DefaultError, Options<CreateDebtForgivenessData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createDebtForgiveness({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Déclencher un paiement automatique
 *
 * Initier un prélèvement automatique pour une facture
 */
export const processAutomaticPaymentMutation = (options?: Partial<Options<ProcessAutomaticPaymentData>>): UseMutationOptions<ProcessAutomaticPaymentResponse, DefaultError, Options<ProcessAutomaticPaymentData>> => {
    const mutationOptions: UseMutationOptions<ProcessAutomaticPaymentResponse, DefaultError, Options<ProcessAutomaticPaymentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await processAutomaticPayment({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getAllParentsQueryKey = (options?: Options<GetAllParentsData>) => createQueryKey('getAllParents', options);

/**
 * Récupérer tous les parents
 *
 * Obtenir la liste complète de tous les parents enregistrés dans le système avec leurs enfants
 */
export const getAllParentsOptions = (options?: Options<GetAllParentsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getAllParents({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getAllParentsQueryKey(options)
    });
};

/**
 * Créer un nouveau parent
 *
 * Permet à un administrateur de créer un nouveau parent dans le système
 */
export const createParentMutation = (options?: Partial<Options<CreateParentData>>): UseMutationOptions<CreateParentResponse, DefaultError, Options<CreateParentData>> => {
    const mutationOptions: UseMutationOptions<CreateParentResponse, DefaultError, Options<CreateParentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createParent({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Envoyer un SMS manuel à un parent
 *
 * Permet d'envoyer un SMS personnalisé à un parent
 */
export const sendSmsMutation = (options?: Partial<Options<SendSmsData>>): UseMutationOptions<unknown, DefaultError, Options<SendSmsData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<SendSmsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await sendSms({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Import en masse de parents
 *
 * Permet d'importer plusieurs parents avec leurs enfants en une seule requête
 */
export const bulkImportParentsMutation = (options?: Partial<Options<BulkImportParentsData>>): UseMutationOptions<BulkImportParentsResponse, DefaultError, Options<BulkImportParentsData>> => {
    const mutationOptions: UseMutationOptions<BulkImportParentsResponse, DefaultError, Options<BulkImportParentsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await bulkImportParents({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Relancer une notification échouée
 *
 * Relancer l'envoi d'une notification spécifique qui a échoué
 */
export const retryNotificationMutation = (options?: Partial<Options<RetryNotificationData>>): UseMutationOptions<RetryNotificationResponse, DefaultError, Options<RetryNotificationData>> => {
    const mutationOptions: UseMutationOptions<RetryNotificationResponse, DefaultError, Options<RetryNotificationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await retryNotification({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Relancer toutes les notifications échouées
 *
 * Relancer l'envoi de toutes les notifications qui ont échoué
 */
export const retryAllFailedNotificationsMutation = (options?: Partial<Options<RetryAllFailedNotificationsData>>): UseMutationOptions<RetryAllFailedNotificationsResponse, DefaultError, Options<RetryAllFailedNotificationsData>> => {
    const mutationOptions: UseMutationOptions<RetryAllFailedNotificationsResponse, DefaultError, Options<RetryAllFailedNotificationsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await retryAllFailedNotifications({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Envoyer un rappel de paiement
 *
 * Envoyer un email de rappel au parent concernant une facture impayée
 */
export const sendPaymentReminderMutation = (options?: Partial<Options<SendPaymentReminderData>>): UseMutationOptions<unknown, DefaultError, Options<SendPaymentReminderData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<SendPaymentReminderData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await sendPaymentReminder({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Envoyer le lien de paiement
 *
 * Envoyer par email le lien de paiement pour une facture au parent concerné
 */
export const sendPaymentLinkMutation = (options?: Partial<Options<SendPaymentLinkData>>): UseMutationOptions<unknown, DefaultError, Options<SendPaymentLinkData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<SendPaymentLinkData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await sendPaymentLink({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Renvoyer l'email de facture
 *
 * Renvoyer l'email de facture original au parent concerné
 */
export const resendInvoiceMutation = (options?: Partial<Options<ResendInvoiceData>>): UseMutationOptions<unknown, DefaultError, Options<ResendInvoiceData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<ResendInvoiceData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await resendInvoice({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Générer une facture mensuelle
 *
 * Créer une nouvelle facture mensuelle pour un parent pour la période spécifiée
 */
export const generateMonthlyInvoiceMutation = (options?: Partial<Options<GenerateMonthlyInvoiceData>>): UseMutationOptions<GenerateMonthlyInvoiceResponse, DefaultError, Options<GenerateMonthlyInvoiceData>> => {
    const mutationOptions: UseMutationOptions<GenerateMonthlyInvoiceResponse, DefaultError, Options<GenerateMonthlyInvoiceData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await generateMonthlyInvoice({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Générer les factures mensuelles pour tous les parents
 *
 * Créer les factures mensuelles pour tous les parents ayant des présences enregistrées pour la période spécifiée
 */
export const generateMonthlyInvoicesForAllParentsMutation = (options?: Partial<Options<GenerateMonthlyInvoicesForAllParentsData>>): UseMutationOptions<GenerateMonthlyInvoicesForAllParentsResponse, DefaultError, Options<GenerateMonthlyInvoicesForAllParentsData>> => {
    const mutationOptions: UseMutationOptions<GenerateMonthlyInvoicesForAllParentsResponse, DefaultError, Options<GenerateMonthlyInvoicesForAllParentsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await generateMonthlyInvoicesForAllParents({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Générer les factures mensuelles en mode brouillon
 *
 * Créer les factures mensuelles en mode DRAFT pour preview avant confirmation
 */
export const generateMonthlyInvoicesForAllParentsDraftMutation = (options?: Partial<Options<GenerateMonthlyInvoicesForAllParentsDraftData>>): UseMutationOptions<GenerateMonthlyInvoicesForAllParentsDraftResponse, DefaultError, Options<GenerateMonthlyInvoicesForAllParentsDraftData>> => {
    const mutationOptions: UseMutationOptions<GenerateMonthlyInvoicesForAllParentsDraftResponse, DefaultError, Options<GenerateMonthlyInvoicesForAllParentsDraftData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await generateMonthlyInvoicesForAllParentsDraft({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Confirmer les factures brouillon
 *
 * Confirmer toutes les factures DRAFT d'une période (passer en PENDING et envoyer les notifications)
 */
export const confirmDraftInvoicesMutation = (options?: Partial<Options<ConfirmDraftInvoicesData>>): UseMutationOptions<ConfirmDraftInvoicesResponse, DefaultError, Options<ConfirmDraftInvoicesData>> => {
    const mutationOptions: UseMutationOptions<ConfirmDraftInvoicesResponse, DefaultError, Options<ConfirmDraftInvoicesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await confirmDraftInvoices({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getAllInvitationsQueryKey = (options?: Options<GetAllInvitationsData>) => createQueryKey('getAllInvitations', options);

/**
 * Lister toutes les invitations
 */
export const getAllInvitationsOptions = (options?: Options<GetAllInvitationsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getAllInvitations({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getAllInvitationsQueryKey(options)
    });
};

/**
 * Créer une invitation
 */
export const createInvitationMutation = (options?: Partial<Options<CreateInvitationData>>): UseMutationOptions<CreateInvitationResponse, DefaultError, Options<CreateInvitationData>> => {
    const mutationOptions: UseMutationOptions<CreateInvitationResponse, DefaultError, Options<CreateInvitationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createInvitation({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getAllCoursesQueryKey = (options?: Options<GetAllCoursesData>) => createQueryKey('getAllCourses', options);

/**
 * Récupérer tous les cours
 *
 * Obtenir la liste complète de tous les cours enregistrés dans le système
 */
export const getAllCoursesOptions = (options?: Options<GetAllCoursesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getAllCourses({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getAllCoursesQueryKey(options)
    });
};

/**
 * Créer un nouveau cours
 *
 * Permet de créer un nouveau cours dans le système avec toutes ses caractéristiques
 */
export const createCourseMutation = (options?: Partial<Options<CreateCourseData>>): UseMutationOptions<CreateCourseResponse, DefaultError, Options<CreateCourseData>> => {
    const mutationOptions: UseMutationOptions<CreateCourseResponse, DefaultError, Options<CreateCourseData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createCourse({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Changer un élève de cours
 *
 * Déplacer un élève d'un cours à un autre
 */
export const moveStudentMutation = (options?: Partial<Options<MoveStudentData>>): UseMutationOptions<unknown, DefaultError, Options<MoveStudentData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<MoveStudentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await moveStudent({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Désinscrire un élève d'un cours
 *
 * Retirer un élève d'un cours existant
 */
export const unenrollStudentMutation = (options?: Partial<Options<UnenrollStudentData>>): UseMutationOptions<unknown, DefaultError, Options<UnenrollStudentData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<UnenrollStudentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await unenrollStudent({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Archiver un cours
 *
 * Clôturer un cours en fin d'année : le cours devient en lecture seule, ses présences sont conservées et toutes les inscriptions encore actives sont terminées à la date d'archivage
 */
export const archiveCourseMutation = (options?: Partial<Options<ArchiveCourseData>>): UseMutationOptions<ArchiveCourseResponse, DefaultError, Options<ArchiveCourseData>> => {
    const mutationOptions: UseMutationOptions<ArchiveCourseResponse, DefaultError, Options<ArchiveCourseData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await archiveCourse({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Désarchiver un cours
 *
 * Réactiver un cours archivé. Les inscriptions clôturées lors de l'archivage ne sont pas rouvertes
 */
export const unarchiveCourseMutation = (options?: Partial<Options<UnarchiveCourseData>>): UseMutationOptions<UnarchiveCourseResponse, DefaultError, Options<UnarchiveCourseData>> => {
    const mutationOptions: UseMutationOptions<UnarchiveCourseResponse, DefaultError, Options<UnarchiveCourseData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await unarchiveCourse({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Annuler la désinscription planifiée d'un élève
 *
 * Annuler une désinscription future d'un élève d'un cours
 */
export const cancelUnenrollStudentMutation = (options?: Partial<Options<CancelUnenrollStudentData>>): UseMutationOptions<unknown, DefaultError, Options<CancelUnenrollStudentData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<CancelUnenrollStudentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await cancelUnenrollStudent({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Inscrire un élève à un cours
 *
 * Ajouter un élève à un cours existant
 */
export const enrollStudentMutation = (options?: Partial<Options<EnrollStudentData>>): UseMutationOptions<unknown, DefaultError, Options<EnrollStudentData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<EnrollStudentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await enrollStudent({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Enregistrer une présence
 *
 * Créer un nouvel enregistrement de présence pour un élève dans un cours
 */
export const recordAttendanceMutation = (options?: Partial<Options<RecordAttendanceData>>): UseMutationOptions<RecordAttendanceResponse, DefaultError, Options<RecordAttendanceData>> => {
    const mutationOptions: UseMutationOptions<RecordAttendanceResponse, DefaultError, Options<RecordAttendanceData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await recordAttendance({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Importer un fichier Excel de présences
 *
 * Parse un fichier Excel et retourne les données de présences pour sauvegarde
 */
export const importAttendanceExcelMutation = (options?: Partial<Options<ImportAttendanceExcelData>>): UseMutationOptions<ImportAttendanceExcelResponse, DefaultError, Options<ImportAttendanceExcelData>> => {
    const mutationOptions: UseMutationOptions<ImportAttendanceExcelResponse, DefaultError, Options<ImportAttendanceExcelData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await importAttendanceExcel({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Enregistrer des présences en masse
 *
 * Créer ou mettre à jour plusieurs enregistrements de présence en une seule opération
 */
export const saveBulkAttendancesMutation = (options?: Partial<Options<SaveBulkAttendancesData>>): UseMutationOptions<SaveBulkAttendancesResponse, DefaultError, Options<SaveBulkAttendancesData>> => {
    const mutationOptions: UseMutationOptions<SaveBulkAttendancesResponse, DefaultError, Options<SaveBulkAttendancesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await saveBulkAttendances({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getSignupLinkDataQueryKey = (options: Options<GetSignupLinkDataData>) => createQueryKey('getSignupLinkData', options);

/**
 * Récupérer les données d'un lien d'inscription
 *
 * Retourne les informations pré-remplies associées à un token de lien d'inscription
 */
export const getSignupLinkDataOptions = (options: Options<GetSignupLinkDataData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getSignupLinkData({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getSignupLinkDataQueryKey(options)
    });
};

export const downloadInvoicePdfQueryKey = (options: Options<DownloadInvoicePdfData>) => createQueryKey('downloadInvoicePdf', options);

/**
 * Télécharger une facture en PDF
 *
 * Génère et télécharge la facture au format PDF
 */
export const downloadInvoicePdfOptions = (options: Options<DownloadInvoicePdfData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await downloadInvoicePdf({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: downloadInvoicePdfQueryKey(options)
    });
};

export const getProfileQueryKey = (options: Options<GetProfileData>) => createQueryKey('getProfile', options);

/**
 * Récupérer le profil d'un parent
 *
 * Obtenir les informations détaillées d'un parent par son ID
 */
export const getProfileOptions = (options: Options<GetProfileData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getProfile({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getProfileQueryKey(options)
    });
};

export const getPaymentMethodsQueryKey = (options: Options<GetPaymentMethodsData>) => createQueryKey('getPaymentMethods', options);

/**
 * Récupérer les moyens de paiement
 *
 * Obtenir la liste des moyens de paiement Stripe associés à un parent
 */
export const getPaymentMethodsOptions = (options: Options<GetPaymentMethodsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getPaymentMethods({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getPaymentMethodsQueryKey(options)
    });
};

export const getInvoicesQueryKey = (options: Options<GetInvoicesData>) => createQueryKey('getInvoices', options);

/**
 * Récupérer les factures d'un parent
 *
 * Obtenir la liste de toutes les factures associées à un parent
 */
export const getInvoicesOptions = (options: Options<GetInvoicesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getInvoices({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getInvoicesQueryKey(options)
    });
};

export const getStripePortalSessionQueryKey = (options: Options<GetStripePortalSessionData>) => createQueryKey('getStripePortalSession', options);

/**
 * Obtenir l'URL du portail Stripe
 *
 * Générer une URL vers le portail de gestion des moyens de paiement Stripe
 */
export const getStripePortalSessionOptions = (options: Options<GetStripePortalSessionData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getStripePortalSession({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getStripePortalSessionQueryKey(options)
    });
};

export const getPaymentsQueryKey = (options: Options<GetPaymentsData>) => createQueryKey('getPayments', options);

/**
 * Récupérer tous les paiements du parent
 *
 * Obtenir l'historique complet des paiements (triés par date de création décroissante)
 */
export const getPaymentsOptions = (options: Options<GetPaymentsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getPayments({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getPaymentsQueryKey(options)
    });
};

export const getPaymentDetailQueryKey = (options: Options<GetPaymentDetailData>) => createQueryKey('getPaymentDetail', options);

/**
 * Récupérer le détail d'un paiement
 *
 * Obtenir les détails complets d'un paiement avec sa répartition sur les factures
 */
export const getPaymentDetailOptions = (options: Options<GetPaymentDetailData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getPaymentDetail({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getPaymentDetailQueryKey(options)
    });
};

export const getPaymentStatusQueryKey = (options: Options<GetPaymentStatusData>) => createQueryKey('getPaymentStatus', options);

/**
 * Vérifier le statut d'un paiement HelloAsso
 *
 * Récupérer le statut actuel d'un paiement HelloAsso pour le polling
 */
export const getPaymentStatusOptions = (options: Options<GetPaymentStatusData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getPaymentStatus({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getPaymentStatusQueryKey(options)
    });
};

export const getInvoices1QueryKey = (options: Options<GetInvoices1Data>) => createQueryKey('getInvoices1', options);

/**
 * Récupérer toutes les factures du parent
 *
 * Obtenir la liste complète des factures (triées par date de création décroissante)
 */
export const getInvoices1Options = (options: Options<GetInvoices1Data>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getInvoices1({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getInvoices1QueryKey(options)
    });
};

export const getInvoiceDetailQueryKey = (options: Options<GetInvoiceDetailData>) => createQueryKey('getInvoiceDetail', options);

/**
 * Récupérer le détail d'une facture
 *
 * Obtenir les détails complets d'une facture avec ses allocations de paiement
 */
export const getInvoiceDetailOptions = (options: Options<GetInvoiceDetailData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getInvoiceDetail({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getInvoiceDetailQueryKey(options)
    });
};

export const getDashboardQueryKey = (options: Options<GetDashboardData>) => createQueryKey('getDashboard', options);

/**
 * Récupérer le tableau de bord parent
 *
 * Obtenir le solde, le nombre de factures à régulariser, les dernières factures et paiements
 */
export const getDashboardOptions = (options: Options<GetDashboardData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getDashboard({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getDashboardQueryKey(options)
    });
};

export const accessStripePortalQueryKey = (options: Options<AccessStripePortalData>) => createQueryKey('accessStripePortal', options);

/**
 * Rediriger vers le portail Stripe (legacy)
 *
 * Point d'entrée historique - redirige vers le portail de gestion Stripe
 */
export const accessStripePortalOptions = (options: Options<AccessStripePortalData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await accessStripePortal({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: accessStripePortalQueryKey(options)
    });
};

export const validateInvitationQueryKey = (options: Options<ValidateInvitationData>) => createQueryKey('validateInvitation', options);

/**
 * Valider un token d'invitation
 *
 * Vérifie la validité d'un token d'invitation et retourne les informations associées
 */
export const validateInvitationOptions = (options: Options<ValidateInvitationData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await validateInvitation({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: validateInvitationQueryKey(options)
    });
};

export const getTimeSlotsQueryKey = (options?: Options<GetTimeSlotsData>) => createQueryKey('getTimeSlots', options);

/**
 * Récupérer les créneaux disponibles
 *
 * Retourne la liste de tous les créneaux horaires disponibles
 */
export const getTimeSlotsOptions = (options?: Options<GetTimeSlotsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getTimeSlots({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getTimeSlotsQueryKey(options)
    });
};

export const getSubjectsQueryKey = (options?: Options<GetSubjectsData>) => createQueryKey('getSubjects', options);

/**
 * Récupérer les matières disponibles
 *
 * Retourne la liste de toutes les matières enseignées
 */
export const getSubjectsOptions = (options?: Options<GetSubjectsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getSubjects({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getSubjectsQueryKey(options)
    });
};

export const getSchoolsQueryKey = (options?: Options<GetSchoolsData>) => createQueryKey('getSchools', options);

/**
 * Récupérer les établissements scolaires
 *
 * Retourne la liste des établissements scolaires référencés
 */
export const getSchoolsOptions = (options?: Options<GetSchoolsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getSchools({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getSchoolsQueryKey(options)
    });
};

export const getLevelsQueryKey = (options?: Options<GetLevelsData>) => createQueryKey('getLevels', options);

/**
 * Récupérer les niveaux disponibles
 *
 * Retourne la liste de tous les niveaux scolaires
 */
export const getLevelsOptions = (options?: Options<GetLevelsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getLevels({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getLevelsQueryKey(options)
    });
};

export const getAllCronTasksQueryKey = (options?: Options<GetAllCronTasksData>) => createQueryKey('getAllCronTasks', options);

/**
 * Récupérer toutes les tâches cron disponibles
 *
 * Obtenir la liste complète des tâches cron configurées dans le système
 */
export const getAllCronTasksOptions = (options?: Options<GetAllCronTasksData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getAllCronTasks({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getAllCronTasksQueryKey(options)
    });
};

export const validateResetTokenQueryKey = (options: Options<ValidateResetTokenData>) => createQueryKey('validateResetToken', options);

/**
 * Valider un token de réinitialisation
 *
 * Vérifie si un token de réinitialisation de mot de passe est valide et non expiré
 */
export const validateResetTokenOptions = (options: Options<ValidateResetTokenData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await validateResetToken({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: validateResetTokenQueryKey(options)
    });
};

export const checkoutQueryKey = (options?: Options<CheckoutData>) => createQueryKey('checkout', options);

export const checkoutOptions = (options?: Options<CheckoutData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await checkout({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: checkoutQueryKey(options)
    });
};

export const getAllUsersQueryKey = (options?: Options<GetAllUsersData>) => createQueryKey('getAllUsers', options);

/**
 * Lister tous les utilisateurs
 */
export const getAllUsersOptions = (options?: Options<GetAllUsersData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getAllUsers({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getAllUsersQueryKey(options)
    });
};

export const getStudentsByParentQueryKey = (options: Options<GetStudentsByParentData>) => createQueryKey('getStudentsByParent', options);

/**
 * Récupérer les élèves d'un parent
 *
 * Obtenir la liste des élèves rattachés à un parent
 */
export const getStudentsByParentOptions = (options: Options<GetStudentsByParentData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getStudentsByParent({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getStudentsByParentQueryKey(options)
    });
};

export const getAllPaymentsQueryKey = (options?: Options<GetAllPaymentsData>) => createQueryKey('getAllPayments', options);

/**
 * Récupérer tous les paiements
 *
 * Obtenir la liste de tous les paiements du système
 */
export const getAllPaymentsOptions = (options?: Options<GetAllPaymentsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getAllPayments({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getAllPaymentsQueryKey(options)
    });
};

export const getPaymentByIdQueryKey = (options: Options<GetPaymentByIdData>) => createQueryKey('getPaymentById', options);

/**
 * Obtenir un paiement par ID
 *
 * Récupérer les détails d'un paiement
 */
export const getPaymentByIdOptions = (options: Options<GetPaymentByIdData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getPaymentById({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getPaymentByIdQueryKey(options)
    });
};

export const getStripePaymentMethodsQueryKey = (options: Options<GetStripePaymentMethodsData>) => createQueryKey('getStripePaymentMethods', options);

/**
 * Récupérer les moyens de paiement Stripe
 *
 * Obtenir la liste des moyens de paiement enregistrés sur Stripe pour un parent
 */
export const getStripePaymentMethodsOptions = (options: Options<GetStripePaymentMethodsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getStripePaymentMethods({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getStripePaymentMethodsQueryKey(options)
    });
};

export const getNewEnrollmentsQueryKey = (options?: Options<GetNewEnrollmentsData>) => createQueryKey('getNewEnrollments', options);

/**
 * Récupérer les nouveaux inscrits
 *
 * Obtenir la liste des parents ayant complété l'inscription mais sans inscription à un cours
 */
export const getNewEnrollmentsOptions = (options?: Options<GetNewEnrollmentsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getNewEnrollments({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getNewEnrollmentsQueryKey(options)
    });
};

export const getAllNotificationsQueryKey = (options?: Options<GetAllNotificationsData>) => createQueryKey('getAllNotifications', options);

/**
 * Récupérer toutes les notifications
 *
 * Obtenir une liste paginée de toutes les notifications du système
 */
export const getAllNotificationsOptions = (options?: Options<GetAllNotificationsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getAllNotifications({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getAllNotificationsQueryKey(options)
    });
};

const createInfiniteParams = <K extends Pick<QueryKey<Options>[0], 'body' | 'headers' | 'path' | 'query'>>(queryKey: QueryKey<Options>, page: K) => {
    const params = {
        ...queryKey[0]
    };
    if (page.body) {
        params.body = {
            ...queryKey[0].body as any,
            ...page.body as any
        };
    }
    if (page.headers) {
        params.headers = {
            ...queryKey[0].headers,
            ...page.headers
        };
    }
    if (page.path) {
        params.path = {
            ...queryKey[0].path as any,
            ...page.path as any
        };
    }
    if (page.query) {
        params.query = {
            ...queryKey[0].query as any,
            ...page.query as any
        };
    }
    return params as unknown as typeof page;
};

export const getAllNotificationsInfiniteQueryKey = (options?: Options<GetAllNotificationsData>): QueryKey<Options<GetAllNotificationsData>> => createQueryKey('getAllNotifications', options, true);

/**
 * Récupérer toutes les notifications
 *
 * Obtenir une liste paginée de toutes les notifications du système
 */
export const getAllNotificationsInfiniteOptions = (options?: Options<GetAllNotificationsData>) => {
    return infiniteQueryOptions<GetAllNotificationsResponse, DefaultError, InfiniteData<GetAllNotificationsResponse>, QueryKey<Options<GetAllNotificationsData>>, number | Pick<QueryKey<Options<GetAllNotificationsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetAllNotificationsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getAllNotifications({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getAllNotificationsInfiniteQueryKey(options)
    });
};

export const getFailedNotificationsQueryKey = (options?: Options<GetFailedNotificationsData>) => createQueryKey('getFailedNotifications', options);

/**
 * Récupérer les notifications échouées
 *
 * Obtenir la liste de toutes les notifications avec le statut FAILED
 */
export const getFailedNotificationsOptions = (options?: Options<GetFailedNotificationsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getFailedNotifications({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getFailedNotificationsQueryKey(options)
    });
};

export const getAllInvoicesQueryKey = (options?: Options<GetAllInvoicesData>) => createQueryKey('getAllInvoices', options);

/**
 * Récupérer toutes les factures
 *
 * Obtenir la liste de toutes les factures du système
 */
export const getAllInvoicesOptions = (options?: Options<GetAllInvoicesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getAllInvoices({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getAllInvoicesQueryKey(options)
    });
};

export const getInvoiceByIdQueryKey = (options: Options<GetInvoiceByIdData>) => createQueryKey('getInvoiceById', options);

/**
 * Récupérer une facture par ID
 *
 * Obtenir les détails complets d'une facture spécifique
 */
export const getInvoiceByIdOptions = (options: Options<GetInvoiceByIdData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getInvoiceById({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getInvoiceByIdQueryKey(options)
    });
};

export const getInvoiceItemsQueryKey = (options: Options<GetInvoiceItemsData>) => createQueryKey('getInvoiceItems', options);

/**
 * Récupérer les détails des cours d'une facture
 *
 * Obtenir la liste détaillée des cours facturés avec quantités et montants
 */
export const getInvoiceItemsOptions = (options: Options<GetInvoiceItemsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getInvoiceItems({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getInvoiceItemsQueryKey(options)
    });
};

export const getInvoicesByParentQueryKey = (options: Options<GetInvoicesByParentData>) => createQueryKey('getInvoicesByParent', options);

/**
 * Récupérer les factures d'un parent
 *
 * Obtenir la liste de toutes les factures d'un parent spécifique
 */
export const getInvoicesByParentOptions = (options: Options<GetInvoicesByParentData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getInvoicesByParent({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getInvoicesByParentQueryKey(options)
    });
};

export const getDraftInvoicesQueryKey = (options?: Options<GetDraftInvoicesData>) => createQueryKey('getDraftInvoices', options);

/**
 * Récupérer toutes les factures brouillon
 *
 * Obtenir la liste de toutes les factures en mode DRAFT
 */
export const getDraftInvoicesOptions = (options?: Options<GetDraftInvoicesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getDraftInvoices({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getDraftInvoicesQueryKey(options)
    });
};

export const getAttendancesByStudentQueryKey = (options: Options<GetAttendancesByStudentData>) => createQueryKey('getAttendancesByStudent', options);

/**
 * Récupérer les présences d'un élève
 *
 * Obtenir la liste de toutes les présences d'un élève spécifique
 */
export const getAttendancesByStudentOptions = (options: Options<GetAttendancesByStudentData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getAttendancesByStudent({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getAttendancesByStudentQueryKey(options)
    });
};

export const exportAttendanceExcelQueryKey = (options: Options<ExportAttendanceExcelData>) => createQueryKey('exportAttendanceExcel', options);

/**
 * Télécharger le fichier Excel des présences
 *
 * Génère et télécharge un fichier Excel pré-rempli pour saisie des présences
 */
export const exportAttendanceExcelOptions = (options: Options<ExportAttendanceExcelData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await exportAttendanceExcel({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: exportAttendanceExcelQueryKey(options)
    });
};

export const getAttendancesByDateQueryKey = (options?: Options<GetAttendancesByDateData>) => createQueryKey('getAttendancesByDate', options);

/**
 * Récupérer les présences par date
 *
 * Obtenir la liste de toutes les présences pour une date spécifique
 */
export const getAttendancesByDateOptions = (options?: Options<GetAttendancesByDateData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getAttendancesByDate({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getAttendancesByDateQueryKey(options)
    });
};

export const getAttendancesByCourseQueryKey = (options: Options<GetAttendancesByCourseData>) => createQueryKey('getAttendancesByCourse', options);

/**
 * Récupérer les présences d'un cours
 *
 * Obtenir la liste de toutes les présences pour un cours spécifique
 */
export const getAttendancesByCourseOptions = (options: Options<GetAttendancesByCourseData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getAttendancesByCourse({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getAttendancesByCourseQueryKey(options)
    });
};

export const getAttendancesBySchoolAndDateQueryKey = (options: Options<GetAttendancesBySchoolAndDateData>) => createQueryKey('getAttendancesBySchoolAndDate', options);

/**
 * Récupérer les présences par établissement et date
 *
 * Obtenir toutes les présences d'un établissement pour une date spécifique avec les créneaux horaires
 */
export const getAttendancesBySchoolAndDateOptions = (options: Options<GetAttendancesBySchoolAndDateData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getAttendancesBySchoolAndDate({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getAttendancesBySchoolAndDateQueryKey(options)
    });
};

/**
 * Supprimer un moyen de paiement
 *
 * Supprimer un moyen de paiement Stripe
 */
export const deletePaymentMethodMutation = (options?: Partial<Options<DeletePaymentMethodData>>): UseMutationOptions<unknown, DefaultError, Options<DeletePaymentMethodData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<DeletePaymentMethodData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deletePaymentMethod({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Supprimer un utilisateur
 */
export const deleteUserMutation = (options?: Partial<Options<DeleteUserData>>): UseMutationOptions<unknown, DefaultError, Options<DeleteUserData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<DeleteUserData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteUser({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Supprimer les factures brouillon
 *
 * Supprimer toutes les factures DRAFT d'une période
 */
export const deleteDraftInvoicesMutation = (options?: Partial<Options<DeleteDraftInvoicesData>>): UseMutationOptions<unknown, DefaultError, Options<DeleteDraftInvoicesData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<DeleteDraftInvoicesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteDraftInvoices({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Supprimer une invitation
 */
export const deleteInvitationMutation = (options?: Partial<Options<DeleteInvitationData>>): UseMutationOptions<unknown, DefaultError, Options<DeleteInvitationData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<DeleteInvitationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteInvitation({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
